import {mountInfinityConnect} from './mountInfinityConnect';

mountInfinityConnect(document.getElementById('root'));
